import axios from 'axios';
import { datadogRum } from '@datadog/browser-rum';
import { getEnv, Env, getTTCDomain } from './utils/environmentUtils';

const env = getEnv();
const RUMEnabledEnvs: Env[] = ['development', 'staging', 'prod'];

if (RUMEnabledEnvs.includes(env)) {
    axios.get('/version.json').then((resp) => {
        datadogRum.init({
            applicationId: 'acf0f054-f399-4203-a346-06b58a747cba',
            clientToken: 'pub0925ece415840e362965a0f807584a7e',
            site: 'datadoghq.com',
            service: 'tcx-scinetworkinsightsui',
            // Specify a version number to identify the deployed version of your application in Datadog
            version: resp.data.build,
            env,
            sessionSampleRate: 100,
            trackUserInteractions: true,
            defaultPrivacyLevel: 'allow',
            allowedTracingUrls: [
                `https://${getTTCDomain()}`,
            ],
        });
    })
        .catch((error) => {
            console.error(error);
            console.error('Could not retrieve version - defaulting to package.json');
            datadogRum.init({
                applicationId: 'acf0f054-f399-4203-a346-06b58a747cba',
                clientToken: 'pub0925ece415840e362965a0f807584a7e',
                site: 'datadoghq.com',
                service: 'tcx-scinetworkinsightsui',
                // Specify a version number to identify the deployed version of your application in Datadog
                version: process.env.REACT_APP_VERSION,
                env,
                sessionSampleRate: 100,
                trackUserInteractions: true,
                defaultPrivacyLevel: 'allow',
                allowedTracingUrls: [
                    `https://${getTTCDomain()}`,
                ],
            });
        })
        .finally(() => {
            console.log('datadog RUM initialized');
            datadogRum.startSessionReplayRecording();
        });
}
